import { Component, inject, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environment/environment';
import { ThemeService } from '@services/layout/theme.service';
import { LoadingGkService } from '@services/ui/loading.service';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { LoadingGkComponent } from '@shared/components/loading/loading.component';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { SharedModule } from '@shared/modules/shared.module';
import { Carousel } from 'primeng/carousel';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [RouterOutlet, SharedModule, LoadingGkComponent, ConfirmDialogComponent, ToastComponent],
})
export class AppComponent implements OnInit {
	currentTheme: 'light' | 'dark' = 'light';
	environment = environment;

	public loadingGkService = inject(LoadingGkService);
	private themeService = inject(ThemeService);

	constructor() {
		// Fix carousel touch behavior on mobile devices
		Carousel.prototype.onTouchMove = () => {};
	}

	ngOnInit() {
		this.themeService.theme$.subscribe((theme) => {
			this.currentTheme = theme;
		});

		this.themeService.setTheme(this.currentTheme);
	}

	switchTheme() {
		const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
		this.themeService.setTheme(newTheme);
	}
}
